module.exports = __webpack_public_path__ + "img/sdg2_id.69d8faeb.svg";